<template>
  <Loading v-model:active="loading" loader="dots"/>
  <div v-if="!loading && testRequests">
    <RequestsList
      fromView="requests"
      :title="$t('analysts.requests.requestsMade')"
      :originalObjectsArray="testRequests || []"
      :totalCount="totalCount"
      :currentPage="currentPage"
      :currentSearch="currentSearch"
      @page-change="handlePageChange"
      @search-change="handleSearchInput"
    />
  </div>
</template>

<script setup>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

import RequestsList from '@/components/RequestsListV2.vue'

import { storeToRefs } from 'pinia'
import { useAnalystTestsStore } from '@/stores/analystTests.store'
import { onMounted, ref } from 'vue'
import debounce from 'lodash/debounce'

const currentPage = ref(1)
const currentSearch = ref('')
const store = useAnalystTestsStore()
const { fetchAllTestRequests } = store
const { testRequests, totalCount, loading } = storeToRefs(store)

const debouncedFetch = debounce((searchValue) => {
  currentPage.value = 1
  currentSearch.value = searchValue
  fetchAllTestRequests({
    page: currentPage.value,
    per_page: 4,
    search: currentSearch.value
  })
}, 1000) // 1000ms = 1 second delay

const handlePageChange = (page) => {
  currentPage.value = page
  fetchAllTestRequests({
    page,
    per_page: 4,
    search: currentSearch.value
  })
}

const handleSearchInput = (search) => {
  debouncedFetch(search)
}

// Get requests
onMounted(() => {
  fetchAllTestRequests({
    page: currentPage.value,
    per_page: 4,
    search: currentSearch.value
  })
})
</script>
